// extracted by mini-css-extract-plugin
export default {"container":"Header_container__TsUVY","leftArea":"Header_leftArea__YU00v","rightArea":"Header_rightArea__Inw7L","centerArea":"Header_centerArea__+kcO0","logo":"Header_logo__shVBB"};